<template>
  <w-button
    class="btn-light mr-2 mb-2"
    :class="action.class"
    :icon="action.icon"
    :text="action.tooltipText || action.name"
    :style="{ color: actionColor }"
    @click="$emit(action.event, { action })"
  />
</template>

<script>
import { actionMixin } from '@/mixins/action';

// @vuese
// Pojedyncza akcja listy dokumentów
// @group Components
export default {
  mixins: [actionMixin]
};
</script>
